import { type ColumnsType } from 'antd/es/table';
import React from 'react';

import DetailPageHeader from '../components/detail-page-header';
import Link from '../components/link';
import TableComponent from '../components/table';

interface VendorRow {
  key: string;
  code: string;
  name: string;
  settingsPath: string;
}

const columns: ColumnsType<VendorRow> = [
  {
    title: 'Code',
    dataIndex: 'code',
    width: '20%',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    width: '40%',
  },
  {
    title: 'Settings',
    dataIndex: 'settingsPath',
    render: (path: string, record: VendorRow): React.ReactElement => (
      <Link to={path} label={`Configure ${record.name}`} />
    ),
    width: '40%',
  },
];

const vendors: VendorRow[] = [
  {
    key: 'PACKETA',
    code: 'PACKETA',
    name: 'Packeta',
    settingsPath: '/packets/vendor/packeta',
  },
];

function PacketsVendorsContainer(): React.ReactElement {
  return (
    <>
      <DetailPageHeader title="Packet vendors" />
      <TableComponent
        columns={columns as Parameters<typeof TableComponent>[0]['columns']}
        dataSource={vendors}
        isLoading={false}
        pagination={false}
        size="small"
      />
    </>
  );
}

export default PacketsVendorsContainer;
